{
  "familyId": "MET-OMTREK-RECHT",
  "questions": [
    {
      "id": "MET-OMTREK-RECHT-001",
      "familyId": "MET-OMTREK-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "omtrek_rechthoek",
      "questionType": "multiple_choice",
      "question": "Een rechthoek is 12 cm lang en 4 cm breed. Wat is de omtrek?",
      "context": null,
      "options": ["32 cm", "48 cm", "16 cm", "28 cm"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geo",
          "data": {
            "width": 12,
            "height": 4,
            "showGrid": false,
            "unit": "cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Omtrek rechthoek",
            "content": "Omtrek = alle zijden bij elkaar optellen.\nEen rechthoek heeft 2 lange en 2 korte zijden.\nFormule: omtrek = 2 × (lengte + breedte)\nHier: 2 × (12 + 4) = 2 × 16 = 32 cm.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "omtrek_rechthoek_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De omtrek is alle zijden bij elkaar. Een rechthoek heeft 4 zijden: 12 + 4 + 12 + 4 = 32 cm. Je kunt ook de formule gebruiken: omtrek = 2 × (lengte + breedte) = 2 × (12 + 4) = 2 × 16 = 32 cm. Waarom × 2? Omdat een rechthoek twee paar gelijke zijden heeft.",
        "solutionSteps": [
          "Schrijf de formule op: omtrek = 2 × (lengte + breedte)",
          "Vul in: 2 × (12 + 4) = 2 × 16",
          "Bereken: 2 × 16 = 32 cm",
          "Controleer: 12 + 4 + 12 + 4 = 32 cm ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! De omtrek is 2 × (12 + 4) = 32 cm. Alle vier de zijden bij elkaar opgeteld.",
          "1": "Je dacht waarschijnlijk aan de oppervlakte. Maar 48 = 12 × 4 is de oppervlakte (in cm²), niet de omtrek. Omtrek = zijden optellen, oppervlakte = zijden vermenigvuldigen. Onthoud: omtrek = 2 × (l + b).",
          "2": "Je dacht waarschijnlijk dat je maar 2 zijden optelt. Maar 16 = 12 + 4 is slechts de helft. Een rechthoek heeft 4 zijden: 12 + 4 + 12 + 4 = 32 cm. Onthoud: omtrek = 2 × (l + b).",
          "3": "Je dacht waarschijnlijk dat je 3 zijden optelt. Maar 28 = 12 + 4 + 12 mist de laatste korte zijde. Een rechthoek heeft 4 zijden. Onthoud: omtrek = 2 × (l + b) = 32 cm."
        }
      }
    },
    {
      "id": "MET-OMTREK-RECHT-002",
      "familyId": "MET-OMTREK-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "omtrek_rechthoek",
      "questionType": "multiple_choice",
      "question": "Een tuinier wil een hek plaatsen rondom een rechthoekig bloembed van 8 m lang en 3 m breed. Hoeveel meter hek heeft hij nodig?",
      "context": "tuinier",
      "options": ["24 m", "11 m", "22 m", "32 m"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "geo",
          "data": {
            "width": 8,
            "height": 3,
            "showGrid": false,
            "unit": "m"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Omtrek in het echt",
            "content": "Een hek rondom een rechthoek = de omtrek.\nOmtrek = 2 × (lengte + breedte)\n= 2 × (8 + 3) = 2 × 11 = 22 m.\n'Rondom' = omtrek!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "omtrek_rechthoek_context",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Een hek rondom een bloembed is de omtrek. Omtrek = 2 × (lengte + breedte) = 2 × (8 + 3) = 2 × 11 = 22 m. Waarom is dit de omtrek? Omdat het hek langs alle vier de zijden loopt — je loopt als het ware één rondje om het bloembed.",
        "solutionSteps": [
          "Herken: 'rondom' = omtrek berekenen",
          "Formule: omtrek = 2 × (lengte + breedte)",
          "Vul in: 2 × (8 + 3) = 2 × 11 = 22 m",
          "Controleer: 8 + 3 + 8 + 3 = 22 m ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk aan de oppervlakte. Maar 24 = 8 × 3 is de oppervlakte (in m²). De vraag is hoeveel meter hek — dat is de omtrek. Onthoud: hek rondom = omtrek.",
          "1": "Je dacht waarschijnlijk dat je maar 2 zijden optelt. Maar 11 = 8 + 3 is de helft. Het hek gaat helemaal rondom: 2 × 11 = 22 m. Onthoud: omtrek = 2 × (l + b).",
          "2": "Goed! 2 × (8 + 3) = 22 m hek nodig. 'Rondom' betekent de omtrek.",
          "3": "Je dacht waarschijnlijk dat je alle getallen vermenigvuldigt. Maar 32 = 8 × 4 of 8 × 3 + 8 klopt niet. De omtrek is 2 × (8 + 3) = 22 m. Onthoud: omtrek = optellen, niet vermenigvuldigen."
        }
      }
    },
    {
      "id": "MET-OMTREK-RECHT-003",
      "familyId": "MET-OMTREK-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "omtrek_rechthoek",
      "questionType": "multiple_choice",
      "question": "Een rechthoek heeft een omtrek van 30 cm. De lengte is 10 cm. Hoe breed is de rechthoek?",
      "context": null,
      "options": ["10 cm", "5 cm", "20 cm", "15 cm"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Omtrek terugrekenen",
            "content": "Omtrek = 2 × (lengte + breedte)\n30 = 2 × (10 + breedte)\n15 = 10 + breedte\nbreedte = 15 − 10 = 5 cm\nTruc: deel de omtrek eerst door 2!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "omtrek_rechthoek_terugrekenen",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Omtrek = 2 × (lengte + breedte). Vul in: 30 = 2 × (10 + breedte). Deel beide kanten door 2: 15 = 10 + breedte. Trek 10 af: breedte = 5 cm. Waarom eerst door 2 delen? Omdat de omtrek twee paar zijden bevat — door 2 te delen krijg je lengte + breedte samen.",
        "solutionSteps": [
          "Schrijf de formule op: omtrek = 2 × (lengte + breedte)",
          "Vul in wat je weet: 30 = 2 × (10 + breedte)",
          "Deel door 2: 15 = 10 + breedte",
          "Trek de lengte af: breedte = 15 − 10 = 5 cm",
          "Controleer: 2 × (10 + 5) = 2 × 15 = 30 cm ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de breedte gelijk is aan de lengte. Maar dan zou de omtrek 2 × (10 + 10) = 40 cm zijn, niet 30 cm. De breedte is 5 cm. Onthoud: reken terug met de formule.",
          "1": "Goed! 30 ÷ 2 = 15, en 15 − 10 = 5 cm. Controleer: 2 × (10 + 5) = 30 ✓",
          "2": "Je dacht waarschijnlijk dat je de lengte van de omtrek aftrekt: 30 − 10 = 20. Maar je vergeet dat er twee lange zijden zijn. Eerst door 2 delen: 30 ÷ 2 = 15, dan 15 − 10 = 5 cm.",
          "3": "Je dacht waarschijnlijk dat je de omtrek door 2 deelt en klaar bent: 30 ÷ 2 = 15. Maar 15 is lengte + breedte samen. Je moet nog de lengte aftrekken: 15 − 10 = 5 cm."
        }
      }
    },
    {
      "id": "MET-OMTREK-RECHT-004",
      "familyId": "MET-OMTREK-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "omtrek_rechthoek",
      "questionType": "multiple_choice",
      "question": "Een vierkant heeft een omtrek van 36 cm. Hoe lang is één zijde?",
      "context": null,
      "options": ["18 cm", "6 cm", "12 cm", "9 cm"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Omtrek vierkant",
            "content": "Een vierkant heeft 4 gelijke zijden.\nOmtrek = 4 × zijde\nDus: zijde = omtrek ÷ 4\nHier: 36 ÷ 4 = 9 cm.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "omtrek_vierkant_terugrekenen",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Een vierkant heeft 4 gelijke zijden. Omtrek = 4 × zijde, dus zijde = omtrek ÷ 4 = 36 ÷ 4 = 9 cm. Waarom door 4 delen? Omdat de omtrek uit 4 gelijke stukken bestaat. Controleer: 4 × 9 = 36 cm ✓",
        "solutionSteps": [
          "Herken: een vierkant heeft 4 gelijke zijden",
          "Formule: omtrek = 4 × zijde, dus zijde = omtrek ÷ 4",
          "Bereken: 36 ÷ 4 = 9 cm",
          "Controleer: 4 × 9 = 36 cm ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je door 2 moet delen. Maar 36 ÷ 2 = 18 is de helft van de omtrek (2 zijden), niet één zijde. Een vierkant heeft 4 zijden: 36 ÷ 4 = 9 cm.",
          "1": "Je dacht waarschijnlijk dat je door 6 moet delen. Maar een vierkant heeft 4 zijden, niet 6. 36 ÷ 4 = 9 cm. Onthoud: vierkant = 4 zijden.",
          "2": "Je dacht waarschijnlijk dat je door 3 moet delen. Maar 36 ÷ 3 = 12 klopt niet — een vierkant heeft 4 zijden, niet 3. Dat is een driehoek! 36 ÷ 4 = 9 cm.",
          "3": "Goed! 36 ÷ 4 = 9 cm per zijde. Controleer: 4 × 9 = 36 ✓"
        }
      }
    },
    {
      "id": "MET-OMTREK-RECHT-005",
      "familyId": "MET-OMTREK-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "omtrek_rechthoek",
      "questionType": "fill_in",
      "question": "Een schilderij is 60 cm lang en 40 cm breed. Je wilt er een lijst omheen maken. Hoeveel centimeter lijst heb je nodig? Typ je antwoord.",
      "context": "kunstenaar",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["200", "200 cm", "200cm"],
        "caseSensitive": false,
        "placeholder": "... cm"
      },
      "stimulusAids": [
        {
          "type": "geo",
          "data": {
            "width": 60,
            "height": 40,
            "showGrid": false,
            "unit": "cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lijst = omtrek",
            "content": "Een lijst rondom een schilderij = de omtrek.\nOmtrek = 2 × (lengte + breedte)\n= 2 × (60 + 40) = 2 × 100 = 200 cm.\nDat is 2 meter lijst!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "omtrek_rechthoek_context_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Een lijst rondom een schilderij is de omtrek. Omtrek = 2 × (lengte + breedte) = 2 × (60 + 40) = 2 × 100 = 200 cm. Dat is 2 meter lijst. Waarom is dit de omtrek? Omdat de lijst langs alle vier de zijden van het schilderij loopt.",
        "solutionSteps": [
          "Herken: lijst rondom = omtrek berekenen",
          "Formule: omtrek = 2 × (lengte + breedte)",
          "Vul in: 2 × (60 + 40) = 2 × 100 = 200 cm",
          "Controleer: 60 + 40 + 60 + 40 = 200 cm = 2 m ✓"
        ]
      }
    }
  ]
}